/**
 * By lsy
 * 登录切换部门
 */
import React, {Component} from 'react';
import {Modal, Button, message} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import Background from './image/公司banner.png'
import {setInfoToLocalStorage} from "../../../actions";
import {Scrollbars} from "react-custom-scrollbars";

export default class ChangeDept extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            deptList: [],
            currentClick: {}
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div>
                {this.renderModal()}
            </div>
        )
    }

    // 弹框
    renderModal = () => {
        let {deptList} = this.state;
        let changeColor = this.themeBgColor;
        return (
            <div style={{display: 'flex'}}>
                <Modal
                    className={'deptLoginModal'}
                    title="请选择登录部门"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    // onCancel={this.handleCancel}
                    width={400}
                    style={{alignSelf: 'center'}}
                    centered={true}
                    maskStyle={{backgroundImage: `url(${Background})`}}
                    footer={[
                        <Button onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" onClick={this.handleOk}
                                style={{background: `${changeColor}`, borderColor: `${changeColor}`}}>确定</Button>
                    ]}
                >
                    <Scrollbars style={{height: 165, bottom: 5}} autoHide>
                        <ul style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            margin: '10px',
                            listStyle:'none',
                            padding:0
                        }}>
                            {deptList.map((item, index) => {
                                return (
                                    <li key={item.deptId}>
                                        <Button className={'itemClick'} style={{
                                            textAlign: 'start',
                                            marginBottom: 16,
                                            cursor: 'pointer',
                                            listStyle: 'none',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                            color: item.checked ? this.themeBgColor : '#000000',
                                            borderColor: item.checked ? this.themeBgColor : "#e5e7f5",
                                            backgroundColor: '#f5f9fc'
                                        }} block={true} onClick={() => {
                                            this.itemClick(item, index);
                                        }}>{item.name || ''}</Button>
                                    </li>
                                )
                            })}
                        </ul>
                    </Scrollbars>
                    <div style={{
                        width: 352,
                        height: 32,
                        borderRadius: 2,
                        background: 'rgba(245,108,108,0.10)',
                        color: '#F56C6C',
                        listStyle: 'none',
                        marginTop: '-2px',
                        padding: "6px 12px",
                        lineHeight: "20px"
                    }}>
                        注：登录后可在系统右上角对部门进行切换
                    </div>
                </Modal>
                <style>
                    {`
                    .deptLoginModal .ant-modal-close-x{
                     display:none !important;
                    }
                    .deptLoginModal .ant-modal-footer{
                     text-align:center !important;
                    }
                    // .deptLoginModal .ant-btn:hover{
                    //    color:${changeColor};
                    //    border-color:${changeColor}
                    // }
                    `}
                </style>
            </div>
        )
    };
    // 显示
    showModal = (list, key, callback) => {
        this.callback = callback;
        this.setState({
            visible: true,
            deptList: list,
            key: key,
        });
    };
    // 确定
    handleOk = () => {
        if (!(this.state.currentClick && this.state.currentClick.deptId)) {
            message.destroy();
            message.error('请选择部门！');
            return
        }
        let roleCodesStr = this.state.currentClick.roleCodes.join();
        let body = {
            deptId: this.state.currentClick.deptId,
            key: this.state.key,
            loginType: 'userKey',
            roleCodes: roleCodesStr,
        };
        // console.log(this.state.currentClick)
        // setInfoToLocalStorage("defaultDetp", this.state.currentClick)
        this.request({
            url: "/cm-sites-sys/v2/login",
            body: body,
            method: 'post',
            contentType: 'form-data',
            haveToken: false,
            callBack: (res) => {
                // console.log(res)
                if (res && res.data) {
                    this.callback && this.callback(res.data)
                }
            }
        })
    };
    // 取消
    handleCancel = e => {
        console.log(e);
        this.props.refreshCode();
        this.setState({
            visible: false,
        });
    };

    // 点击当前
    itemClick(item, index) {
        // console.log(item, index)
        this.state.deptList.forEach(record => {
            // console.log(record)
            record.checked = false;
        });
        this.state.deptList[index].checked = true;
        this.setState({currentClick: item});
    }
};

ChangeDept.defaultProps = {};
ChangeDept.propTypes = {};